"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _btnPropTypes = require("./btnPropTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * ButtonWrapper - to be used to wrap a component into a button
 * This will take any type of child and css class for different looks for buttons
*/
var ButtonWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ButtonWrapper, _React$Component);

  function ButtonWrapper(props) {
    var _this;

    _classCallCheck(this, ButtonWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ButtonWrapper).call(this, props));
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.buttonProps = _this.buttonProps.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ButtonWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.doFocus !== this.props.doFocus) {
        this.handleFocus();
      }
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var doFocus = this.props.doFocus;
      (0, _utils.focusHandler)(this.wrapperRef, doFocus);
    }
  }, {
    key: "buttonProps",
    value: function buttonProps() {
      var _this$props = this.props,
          type = _this$props.type,
          cssClass = _this$props.cssClass,
          cashbotName = _this$props.cashbotName,
          ariaLabel = _this$props.ariaLabel,
          ariaDescribedBy = _this$props.ariaDescribedBy,
          atts = _this$props.atts,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;

      var modifiedOnClick = function modifiedOnClick() {
        // The skip to error link should be focused, if the element is present
        var element = document.getElementById("skipToErrorLink");

        if (element) {
          element.focus();
        }

        onClick();
      };

      var buttonAttrs = _objectSpread({
        onClick: modifiedOnClick,
        type: type,
        disabled: disabled,
        className: cssClass
      }, (0, _utils.getCashbotButtonAttrs)(cashbotName, type), atts);

      if (ariaLabel) {
        buttonAttrs['aria-label'] = ariaLabel;
      }

      if (ariaDescribedBy) {
        buttonAttrs['aria-describedby'] = ariaDescribedBy;
      }

      return buttonAttrs;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("button", _extends({
        ref: this.setWrapperRef
      }, this.buttonProps()), this.props.children);
    }
  }]);

  return ButtonWrapper;
}(_react.default.Component);

exports.ButtonWrapper = ButtonWrapper;
ButtonWrapper.defaultProps = _objectSpread({}, _btnPropTypes.wrapperDefaults);
ButtonWrapper.propTypes = _objectSpread({}, _btnPropTypes.wrapperPropTypes);